/**
 * Nueva fórmula de cálculo de propinas con checkboxes
 * 
 * PT(U_i) = v_0 / (Σ r(U_j)ρ_j) × r(U_i)
 * 
 * Donde:
 * - v_0 = total de propinas para el día
 * - r(U_j) = rate del usuario j (0-100)
 * - ρ_j = 1 si checkbox marcado, 0 si no
 * - r(U_i) = rate del usuario i
 */

/**
 * Calcula la propina para todos los usuarios en una matriz de asistencias
 */
export const calculateTipsForMatrix = (
  dayTotal: number,
  users: { user_id: number; rate: number }[],
  attendanceMap: { [userId: number]: boolean }
): { [userId: number]: number } => {
  const result: { [userId: number]: number } = {};

  // Calcula el denominador: Σ r(U_j)ρ_j
  const sumWeights = users.reduce((sum, user) => {
    const rho = attendanceMap[user.user_id] ? 1 : 0; // 1 si checkbox marcado, 0 si no
    return sum + (user.rate / 100) * rho;
  }, 0);

  // Si nadie tiene checkbox marcado, no hay propina
  if (sumWeights === 0) {
    users.forEach(user => {
      result[user.user_id] = 0;
    });
    return result;
  }

  // Calcula PT(U_i) para cada usuario
  users.forEach(user => {
    const rho = attendanceMap[user.user_id] ? 1 : 0;
    result[user.user_id] = (dayTotal / sumWeights) * (user.rate / 100) * rho;
  });

  return result;
};

/**
 * Formato de moneda
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
